module.exports = __webpack_public_path__ + "79c33aabeabb8073acbb2c832a847cf5.svg";